import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import debounce from 'lodash.debounce';
import CartLoader from "../../../../Helper/Loaders/CartLoader";
import BatteryTreeNode from "../../components/BatteryTreeNode";
import { getNodesAtLevel } from "../../../../Helper/DigitalTwin/DigitalTwinFunctions";
import { useTranslation } from "react-i18next";
import BatterySidebarContainer from "../../components/BatterySidebarContainer";


const BatteryHealthSidebar = ({
    batteryStructure = [],
    onChangeNode = () => { },
    hierarchyLevel,
    batteryConfig,
    title = 'Battery System',
    maxLevel = 5,
}) => {
    const [openNodes, setOpenNodes] = useState({});
    const [selectedIds, setSelectedIds] = useState([]);
    const { t } = useTranslation(['common', 'digital_twin'])
    const [shouldDisableCheckbox, setShouldDisableCheckbox] = useState(false);

    const debouncedOnChange = useCallback(debounce((updatedIds) => {
        onChangeNode(updatedIds);
    }, 800), []);

    const getCountForInitialSelection = () => {
        let defaultCount = 20
        if (!hierarchyLevel) {
            return defaultCount
        }

        if (hierarchyLevel == 'cell') {
            return parseInt(batteryConfig.cellCountPerModule) || defaultCount
        }

        if (hierarchyLevel == 'module') {
            return parseInt(batteryConfig.moduleCountPerPack) || defaultCount
        }

        if (hierarchyLevel == 'pack') {
            return parseInt(batteryConfig.packCount) || defaultCount
        }

        return defaultCount
    }

    useEffect(() => {
        if (!batteryStructure || batteryStructure.length === 0) return;

        const selectionCount = getCountForInitialSelection()
        if (selectionCount == 1) {
            setShouldDisableCheckbox(true)
        }
        const newSelected = getNodesAtLevel(batteryStructure, maxLevel).map(n => n.id);
        const defaultIds = newSelected.slice(0, selectionCount);
        setSelectedIds(defaultIds);
        onChangeNode(defaultIds);

        const traverseToLevel = (node, currentLevel = 0) => {
            if (currentLevel < maxLevel) {
                openNodes[node.id] = true;
                (node.children || []).forEach(child => traverseToLevel(child, currentLevel + 1));
            }
        };

        batteryStructure.forEach(root => traverseToLevel(root));
        setOpenNodes(openNodes);

    }, [maxLevel, batteryStructure]);

    if (!batteryStructure || batteryStructure.length === 0) {
        return <CartLoader />;
    }

    return (

        <BatterySidebarContainer title={title}>
            <Box sx={{ overflow: "auto", height: '550px', pb: 4 }}>
                {batteryStructure.map((node) => (
                    <BatteryTreeNode
                        key={node.id}
                        node={node}
                        level={0}
                        shouldDisableCheckbox={shouldDisableCheckbox}
                        maxLevel={maxLevel}
                        openNodes={openNodes}
                        setOpenNodes={setOpenNodes}
                        selectedIds={selectedIds}
                        setSelectedIds={setSelectedIds}
                        onChangeNode={debouncedOnChange}
                    />
                ))}
            </Box>
        </BatterySidebarContainer>
    );
};

export default BatteryHealthSidebar;
